import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
} from '../../../components';
import Apis from '../../../apis';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { Nullable } from '../../../types';
import { PHIWH, StudentGradeNoSeat, StudentWH, UserInfo } from '../../../model';
import {
  Col,
  Container,
  Dropdown,
  DropdownButton,
  FormControl,
  Modal,
  Row,
  Button,
} from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { ClassSem, WrapClassBaseLayout } from '../../../layouts';
import { ApplicationState } from '../../../redux/States';
import { WHPropertyFields, WHTableHeader } from './../../TableHeaders/WHHeader';
import { semesterRange } from '../../../utils/date';
import { useSemGrade } from '../../../hook';
import {
  SheetHeaderDisplay,
  downloadDataAsExcel,
  printDataAsTable,
} from '../../../utils';
import { SightContext } from '../../TableHeaders/SightHeader';

type MetricPageData = StudentGradeNoSeat & Nullable<PHIWH>;

const displayHeader: (SheetHeaderDisplay<MetricPageData> &
  HeaderDisplayKeysWithType<MetricPageData>)[] = [
    { property: 'pid', display: '統編' },
    { property: 'name', display: '學生' },
    {
      display: '性別',
      property: 'sex',
      onRender: (v) => (v === '1' ? '男' : '女'),
      onSheetRender: (v) => (v === '1' ? '男' : '女'), style: { width: "7%" }
    },
    { property: 'grade', display: '年級' },
    {
      property: 'className',
      display: '班級',
    },
    { property: 'seat', display: '座號' },
    { property: 'height', display: '身高' },
    { property: 'weight', display: '體重' },
    { display: 'BMI', property: 'bmi' },
  ];

const modalDisplayHeader: HeaderDisplayKeysWithType<PHIWH>[] = [
  { property: 'year', display: '學年' },
  { property: 'sem', display: '學期' },
  ...WHTableHeader,
];

const mapState = (state: ApplicationState, ownProps: ClassSem) => ({
  ...ownProps,
  ...state.auth,
});
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

const wHUnCheck: FunctionComponent<Props> = ({
  user,
  catchErrorForModal,
}) => {
  const { currentSemester = '', semesters = {} } = user || {};
  const [currentSem, setCurrentSem] = useState(currentSemester);
  let { year = -1, sem = -1 } = semesters[currentSem];
  const { yearSem, element: semGradeElement } = useSemGrade();
  // const [students, setStudent] = useState([] as MetricPageData[]);
  const [students, setStudents] = useState<MetricPageData[]>([]);
  const [inputing, setInputing] = useState(false);
  const [editingStudent, setEditingStudent] = useState<MetricPageData>();
  const [userinfo, setUser] = useState<UserInfo>();
  useEffect(() => {
    if (yearSem) {
      Apis.getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(catchErrorForModal);
      toast
        .promise(
          Apis
            .getClassStudentUnCheck(yearSem.year, yearSem.sem)
            .then(r => {
              setStudents(
                r.map(({ wH, ...s }) => ({
                  ...wH,
                  ...s,
                }))
              )
            }),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
        .catch(catchErrorForModal);

    }
  }, [yearSem?.year, yearSem?.sem, inputing]);

  function onHide() {
    setInputing(false);
    setEditingStudent(undefined);
  }

  function onEditMetric(metric: MetricPageData) {
    setInputing(true);
    setEditingStudent(metric);
  }

  async function onUpdateStudentMetric(metric: PHIWH) {
    if (editingStudent && editingStudent.pid && yearSem) {
      toast
        .promise(Apis.InsertStudentBodyMetrix(editingStudent?.pid, metric), {
          pending: '資料上傳中......',
          success: '上傳成功！',
          error: '上傳失敗！請查看錯誤資訊。',
        })
        .then(() => {
          onHide();
        })
        .catch(catchErrorForModal);
    }
  }

  return (
    <AuthedLayout>
      <Row className="justify-content-between">
        <Col>
          <Row>
            <Col xs={3} className="mr-3">
              {semGradeElement}
            </Col>
          </Row>
        </Col>
        <div>
          <DropdownButton
            id="wh-uncheck-export"
            title="匯出"
            variant="success"
            disabled={!students.length}
          >
            <Dropdown.Item
              onClick={() => {
                downloadDataAsExcel({
                  title:
                    `${user.schools[user.currentSchool].name}` +
                    `${yearSem?.year}學年` +
                    `${yearSem?.sem}學期_生長發育未測量名單`,
                  values: students,
                  headers: displayHeader,
                  context: SightContext,
                  footer:
                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                  exportfile: userinfo?.exportFileType,
                });
              }}
            >
              Excel 下載
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => {
                printDataAsTable({
                  title:
                    `${user.schools[user.currentSchool].name}` +
                    `${yearSem?.year}學年` +
                    `${yearSem?.sem}學期_生長發育未測量名單`,
                  values: students,
                  headers: displayHeader,
                  context: SightContext,
                  footer:
                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                });
              }}
            >
              列印
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </Row>
      <hr />
      <Row>
        <EditableTableDiv
          values={students}
          headers={displayHeader}
          onEdit={onEditMetric}
        />
      </Row>
      <Modal
        show={inputing}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        dialogClassName="modal-dialog-full"
        centered
      >
        <Modal.Header closeButton onHide={onHide}>
          <Modal.Title id="contained-modal-title-vcenter">
            身高體重 -{' '}
            <strong>
              {editingStudent?.seat} {editingStudent?.name}
            </strong>
          </Modal.Title>
        </Modal.Header>
        <Form
          initialValues={editingStudent}
          onSubmit={(value) => {
            const data = {
              id: 0,
              sem,
              year,
              height: value.height,
              weight: value.weight,
              examDate: value.examDate,
              yearClassId: 0,
            };
            onUpdateStudentMetric(data);
          }}
          subscription={{ submitting: true, pristine: true }}
          render={(prop) => {
            if (yearSem) {
              year = yearSem.year;
              sem = yearSem.sem;
            }
            const { handleSubmit } = prop;
            const [fromDate, toDate] = semesterRange(year, sem);
            return (
              <React.Fragment>
                <Modal.Body className="text-center">
                  <Container>
                    <Row>
                      <Col sm="8">
                        <EditableTableDiv
                          values={editingStudent ? [editingStudent as unknown as PHIWH] : []}
                          headers={modalDisplayHeader}
                        />
                      </Col>
                      <Col sm="4">
                        <Row className="pb-3 justify-content-center align-items-center">
                          <Col sm="3">身高:</Col>
                          <Col sm="8">{WHPropertyFields['height']}</Col>
                        </Row>

                        <Row className="pb-3 justify-content-center align-items-center">
                          <Col sm="3">體重:</Col>
                          <Col sm="8">{WHPropertyFields['weight']}</Col>
                        </Row>

                        <Row className="pb-3 justify-content-center align-items-center">
                          <Col sm="3">檢查日期:</Col>
                          <Col sm="8">
                            {WHPropertyFields['examDate'](fromDate, toDate)}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit" onClick={handleSubmit}>
                    儲存
                  </Button>
                  <Button type="reset" variant="secondary" onClick={onHide}>
                    關閉
                  </Button>
                </Modal.Footer>
              </React.Fragment>
            );
          }}
        />
      </Modal>
    </AuthedLayout>
  );
};

export const WHUnCheck = connector(wHUnCheck);
